export default "__VITE_ASSET__NKZ1XMtb__"